<app-common-loader></app-common-loader>
<router-outlet></router-outlet>
<app-toaster></app-toaster>
<app-alert></app-alert>
